import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const API_URL = window.location.origin;

/**
 * Constructs a full URL for profile images
 * Handles base64 data URLs, relative paths from database and absolute URLs
 * @param {string|null|undefined} imagePath - The image path from the database
 * @returns {string|undefined} - Full URL or undefined if no path
 */
export function getProfileImageUrl(imagePath) {
  if (!imagePath) return undefined;
  // Handle base64 data URLs directly
  if (imagePath.startsWith('data:')) return imagePath;
  // Handle full URLs
  if (imagePath.startsWith('http')) return imagePath;
  // Handle paths that already include /api/ prefix - avoid double /api/api/
  if (imagePath.startsWith('/api/')) {
    return `${API_URL}${imagePath.substring(4)}`; // Remove /api prefix
  }
  // Handle relative paths
  return `${API_URL}${imagePath}`;
}

/**
 * Normalize a value that should be an array of strings but may come back
 * as a comma/semicolon/pipe-separated string from older records or buggy
 * admin inputs. Returns an array of trimmed non-empty strings.
 * Use this for fields like coach.specialties / coach.credentials before
 * calling .slice(...).map(...).
 * @param {any} val
 * @returns {string[]}
 */
export function toStringArray(val) {
  if (Array.isArray(val)) return val.map((s) => String(s).trim()).filter(Boolean);
  if (typeof val === 'string') {
    return val.split(/[,;|]/).map((s) => s.trim()).filter(Boolean);
  }
  return [];
}

